<template>
	<v-container fluid>
		<div style="height: 60px;"></div>
		<v-container v-if="list.length==0">
			<div class="justify-center d-flex flex-column align-center">
				
				
				<v-icon size="100">mdi-emoticon-outline</v-icon>
				<div style="font-size: 31px;">空空如也,什么都没有。</div>
				<div style="font-size: 12px;"><v-btn color="primary">试试手气~</v-btn></div>
			</div>
		</v-container>
		<v-row v-if="list.length>0">
			<v-col v-for="(item,index) in list" :key="index" cols="12" lg="3" md="4" sm="6" xs="12" xl="3">
				<v-item v-slot="{ active, toggle }"><tm-listItem :item="item"></tm-listItem></v-item>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import tmListItem from '../../components/tm-listItem.vue';
export default {
	name: 'mall-index',
	components: {
		tmListItem
	},

	data: () => ({
		isLoading:false,
		page:1,
		list:[],
		pageCount:1,
	}),
	mounted() {
		this.getList();
	},
	methods: {
		resetList(){
			this.page = 1;
			this.pageCount =1;
			this.list = [];
			this.isLoading = false;
			this.getList()
		},
		getList() {
			// if (!this.$store.state.token) return;
			if (this.page > this.pageCount) return;
			if(this.isLoading) return;
			this.isLoading = true;
			this.$fetch('/tmui/pulickGetMobanList/?page=' + this.page, {
					method: 'get'
				})
				.then(data => {
					// this.page += 1;
					this.pageCount = data.pageCount;
					this.list = data.data;
					this.isLoading = false;
				})
				.catch(e => {
					this.isLoading = false;
				});
		},
	}
};
</script>
<style></style>
